
import React, { useEffect } from "react";
import { convertAdUrl, translateText } from "../../utils/utils";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import Translate from "../MultiLanguage/Translate"

const ContinueWatchingModel = (props) => {

  const { t } = useTranslation();
  const languageModal = useSelector((state) => state?.languageModal?.value);

  useEffect(() => {
    props?.watchedLength && ContinueWatchingHandler("yes") // clicked from home - continue watching row

  }, [])

  const ContinueWatchingHandler = async (value) => {
    if (value === "yes") {
      props?.playVideo(
        props?.videoDetails?.watched_duration
      );
      props?.setIsContinueWatchingModal(false)

    } else if (value === "no") {
      props?.playVideo();
      props?.setIsContinueWatchingModal(false)
    }
  };
  return (
    <div className="continueWatching">
      <div className="overlayModal"></div>
      <div className="contents">
        <h1><Translate textKey={'continue_from_stopped'} /></h1>
        <div className="buttons">
          <div
            className="buttonContainer"
            onClick={() => ContinueWatchingHandler("yes")}
          >
            <div className="background"></div>
            <button><Translate textKey={'yes'} /></button>
          </div>

          <div
            className="buttonContainer"
            onClick={() => ContinueWatchingHandler("no")}
          >
            <div className="background"></div>
            <button><Translate textKey={'no'} /></button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContinueWatchingModel;
